var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1071 36.0486C46.406 36.8775 46.7272 38.5163 45.8246 39.709L40.2527 47.0719H52.4888C53.5371 47.0719 54.5016 47.5978 55.0034 48.443C55.5051 49.2882 55.4639 50.3175 54.8959 51.1266L46.6224 62.9123C45.7655 64.1331 43.993 64.4848 42.6636 63.6979C41.3342 62.9109 40.9512 61.2833 41.8082 60.0626L47.2353 52.3316H34.775C33.7089 52.3316 32.7311 51.7878 32.2371 50.9202C31.7431 50.0526 31.8149 49.0049 32.4232 48.201L41.121 36.7075C42.0236 35.5148 43.8083 35.2198 45.1071 36.0486Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3861 44.4414C88.9678 44.4414 90.25 45.6188 90.25 47.0713L90.25 52.5258C90.25 53.9783 88.9678 55.1557 87.3861 55.1557C85.8044 55.1557 84.5222 53.9783 84.5222 52.5258L84.5222 47.0713C84.5222 45.6188 85.8044 44.4414 87.3861 44.4414Z",
    fill: "#9D9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 39.0844C9 34.6195 12.9416 31 17.8039 31H22.8952C24.4769 31 25.7591 32.1774 25.7591 33.6299C25.7591 35.0823 24.4769 36.2597 22.8952 36.2597H17.8039C16.105 36.2597 14.7278 37.5244 14.7278 39.0844V60.4156C14.7278 61.9756 16.105 63.2403 17.8039 63.2403H19.7131C21.2948 63.2403 22.577 64.4177 22.577 65.8701C22.577 67.3226 21.2948 68.5 19.7131 68.5H17.8039C12.9416 68.5 9 64.8805 9 60.4156V39.0844Z",
    fill: "#9D9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5823 39.0844C78.5823 34.6195 74.6407 31 69.7784 31H64.687C63.1054 31 61.8231 32.1774 61.8231 33.6299C61.8231 35.0823 63.1054 36.2597 64.687 36.2597H69.7784C71.4773 36.2597 72.8545 37.5244 72.8545 39.0844V60.4156C72.8545 61.9756 71.4773 63.2403 69.7784 63.2403H61.1867C59.605 63.2403 58.3228 64.4177 58.3228 65.8701C58.3228 67.3226 59.605 68.5 61.1867 68.5H69.7784C74.6407 68.5 78.5823 64.8805 78.5823 60.4156V39.0844Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.ade8c6235f256c91e07515de7e89213e.svg";
export { ForwardRef as ReactComponent };